module.exports = {
  title: "成都斯马特科技股份有限公司",
  // 宠物培训视频网站

  /**
   * @type {boolean} true | false
   * @description 是否显示标签视图
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description 是否固定头部导航
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description 侧边栏是否显示logo
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: "production"
};



// WEBPACK FOOTER //
// ./src/settings.js